import clock from "#/src/assets/svg/clock.svg";
import {ApiArticle} from "#/src/definitions/ApiDefinitions";
import {Link} from "#/src/components/Link";
import {truncateTitle} from "#/src/utils/string-utils";
import {TimeDisplay} from "#/src/components/TimeDisplay";
import {getProfileUrl} from "#/src/utils/profile-url";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

interface Props {
  article: ApiArticle
}

export function HotArticle({article}: Props) {
  return <div className="article-list-block">
    <article className="article-card">
      <div className="article-content">
        <div className="article-tag">
          <a href="#" className="tag-primary">{article.category.name} {" — "}</a>
          <a href="#" className="hot-tag">🔥 HOT</a>
        </div>
        <Link href={`/blog/${article.slug}`} className="article-link">
          {truncateTitle(article.title)}
        </Link>
        <div className="article-author mt-2">
          <div className="author">
            <AvatarWithFallback user={article.author} className={"avatar avatar-20"}/>
            <a href={getProfileUrl(article.author)} className="author-link">{article.author.username}</a>
          </div>
          <div className="article-date">
            <img src={clock} alt="Icon"/>
            <span><TimeDisplay className={"ms-2"} date={article.creationDate}/></span>
          </div>
        </div>
      </div>
    </article>
  </div>
}